import { render, staticRenderFns } from "./manageDiscountLog.vue?vue&type=template&id=2719d916&"
import script from "./manageDiscountLog.vue?vue&type=script&lang=js&"
export * from "./manageDiscountLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports